var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "11px",
    viewBox: "0 0 14 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grey_check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User-Management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Locked(1)",
    transform: "translate(-799.000000, -467.000000)",
    fill: "#717171",
    fillRule: "nonzero",
    stroke: "#717171",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(783.000000, 349.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(17.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.52352089,8.87637562 C3.44223378,8.95543351 3.33515357,8.99960052 3.22380112,9 C3.10600864,8.99949203 2.99331283,8.95002628 2.91085841,8.86263957 L0.129635206,5.97807061 C0.0178315377,5.86192845 -0.0258327676,5.69264755 0.0150902114,5.5339944 C0.0560131904,5.37534125 0.17530628,5.25141903 0.328032924,5.20890805 C0.480759569,5.16639707 0.643716958,5.21175575 0.755520617,5.32789792 L3.2326164,7.90569527 L11.2589357,0.121937746 C11.4378548,-0.0500162597 11.7170866,-0.0387415532 11.8826172,0.147120508 C12.0481479,0.33298257 12.0372944,0.623049811 11.8583752,0.795003838 L3.52352089,8.87637562 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCheck);
export default __webpack_public_path__ + "static/media/grey_check.98c119b25295c2605384e94b07446f82.svg";
export { ForwardRef as ReactComponent };